import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Styles from './marketsList.module.css';
import { ReactComponent as InfoIcon } from '../../../../assets/icons/imported/info.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedMarket } from '../../redux/slices/selectedMarketSlice';
import { clearOrderBook } from '../../redux/slices/orderBookSlice';
import { clearTrades } from '../../redux/slices/tradesSlice';
import { setPreviousMarket } from '../../redux/slices/previousMarketSlice';
import { FormattedMessage, injectIntl } from 'react-intl';
import MarketRow from './MarketRow';
import ShimmerLine from '../../../../components/shimmer-components/ShimmerLine';
import Search from '../../../../components/Search/Search';
import ShimmerCirlce from '../../../../components/shimmer-components/ShimmerCircle';

function MarketsList() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const marketsList = useSelector(state => state.marketList?.value)
  const tickers = useSelector(state => state.marketTickers.value)
  const currencies = useSelector(state => state.currencies.value)
  const [filteredMarketList, setFilteredMarketList] = useState(marketsList)
  const selectedMarket = useSelector(state => state.selectedMarket.value)
  const theme = useSelector(state => state.theme.value)
  const defaultTicker = {
    last: 0,
    vol: 0,
    price_change_percent: '+0.00%'
  }
  const items = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  const { marketName } = useParams()

  // useEffect(() => {
  //   console.log(currencies)
  // }, [currencies])

  const handleSearchChange = event => {
    const searchInput = event.target.value
    setSearch(searchInput)

    if (!searchInput.trim()) {
      setFilteredMarketList(marketsList)
    } else {
      setFilteredMarketList(
        marketsList?.filter(
          pair =>
            pair.name?.toLowerCase().includes(searchInput.toLowerCase()) ||
            pair.id?.toLowerCase().includes(searchInput.toLowerCase()) ||
            pair.coin_name?.toLowerCase().includes(searchInput.toLowerCase())
        )
      )
    }
  }

  const changeCurrency = currency => {
    dispatch(clearOrderBook())
    dispatch(clearTrades())
    setSelectedMarket(currency)
    // console.log(currency)
    dispatch(setSelectedMarket(currency))
    navigate(`/trade/${currency.id}`)
  }

  useEffect(() => {
    // setSelectedMarket({
    //   id: marketsList[0]?.id,
    //   name: marketsList[0]?.name
    // })
    // dispatch(
    //   setSelectedMarket({
    //     id: marketsList[0]?.id,
    //     name: marketsList[0]?.name
    //   })
    // )
    // setSelectedMarket({
    //   id: marketName,
    //   name: marketsList?.find((market) => market.id === marketName)?.name
    // })
    dispatch(
      setSelectedMarket({
        id: marketName,
        name: marketsList?.find(market => market.id === marketName)?.name,
        price_precision: marketsList?.find(market => market.id === marketName)?.price_precision || 0,
        quote_unit: marketsList?.find(market => market.id === marketName)?.quote_unit,
        base_unit: marketsList?.find(market => market.id === marketName)?.base_unit
      })
    )
    console.log(marketsList)
    console.log(marketName)
    if (filteredMarketList?.length) {
      setLoading(false)
    }
    if (!marketName) {
      // setSelectedMarket({
      //   id: marketsList[0]?.id,
      //   name: marketsList[0]?.name
      // })
      dispatch(
        setSelectedMarket({
          id: marketsList[0]?.id,
          name: marketsList[0]?.name,
          price_precision: marketsList[0]?.price_precision || 0,
          quote_unit: marketsList[0]?.quote_unit,
          base_unit: marketsList[0]?.base_unit
        })
      )
      navigate(`/trade/${marketsList[0]?.id}`)
    }
  }, [marketName, marketsList])

  useEffect(() => {
    if (marketsList?.length) {
      setFilteredMarketList(marketsList)
    }
  }, [marketsList])

  useEffect(() => {
    if (tickers && marketsList) {
      const marketsWithTickers = marketsList?.map(market => {
        return {
          ...market,
          last: (tickers[market.id] || defaultTicker).last,
          price_change_percent: (tickers[market.id] || defaultTicker).price_change_percent,
          price_change_percent_num: Number.parseFloat((tickers[market.id] || defaultTicker).price_change_percent),
          vol: (tickers[market.id] || defaultTicker).volume
        }
      })

      // Apply current search filter to the updated markets list
      if (search.trim()) {
        setFilteredMarketList(
          marketsWithTickers?.filter(
            pair =>
              pair.name?.toLowerCase().includes(search.toLowerCase()) ||
              pair.id?.toLowerCase().includes(search.toLowerCase()) ||
              pair.coin_name?.toLowerCase().includes(search.toLowerCase())
          )
        )
      } else {
        setFilteredMarketList(marketsWithTickers)
      }
    }
    // console.log(marketsList)
    // console.log(loading)
    // console.log(tickers)
  }, [tickers, marketsList, search])

  return (
    <div className={`${Styles.card} ${theme === 'light' ? Styles.light : ''}`}>
      <Search
        value={search}
        placeholder='Search Coin Pair'
        onChange={handleSearchChange}
        containerStyle={{
          width: '100%'
        }}
      />

      <div className={Styles.marketPairTableHeader}>
        <span>
          <FormattedMessage id={'page.body.trade.header.markets.content.market'} />
        </span>
        <span>
          <FormattedMessage id={'page.body.trade.header.markets.content.last_price'} />
        </span>
      </div>

      <div className={Styles.rowsContainer} style={{ overflowY: !filteredMarketList?.length && 'hidden' }}>
        {!loading && tickers ? (
          filteredMarketList?.length !== 0 ? (
            filteredMarketList
              ?.filter(pair => pair.last > 0)
              .map(pair => {
                return (
                  <MarketRow
                    key={pair.name}
                    iconURL={pair.icon_url}
                    pair={pair}
                    isSelected={pair.id === marketName}
                    onClick={() => {
                      dispatch(setPreviousMarket(selectedMarket.id))
                      changeCurrency({
                        id: pair.id,
                        name: pair.name,
                        quote_symbol: '',
                        price_precision: pair.price_precision,
                        quote_unit: pair.quote_unit,
                        base_unit: pair.base_unit
                      })
                      setSearch('')
                    }}
                  />
                )
              })
          ) : (
            <div className={Styles.NotFoundContainer}>
              <InfoIcon />
              Pair Not Found
            </div>
          )
        ) : (
          items.map(number => (
            <div className={Styles.loadingRowContainer} key={number}>
              <div>
                <ShimmerCirlce />
                <ShimmerLine width='30px' height='15px' />
              </div>
              <div>
                <ShimmerLine width='70px' />
                <ShimmerLine width='32px' />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}

export default injectIntl(MarketsList)
